import React from 'react';
import PropTypes from 'prop-types';

function SectionBanner({ title, desc, img ,children ,actions}) {

    return (
        <div className=" bg-blue-200 p-4 sm:p-6 rounded overflow-hidden mb-8">
            <div className='flex flex-row justify-between'>


                {/* Content */}
                <div className="mr-16">
                    <h1 className="text-2xl md:text-3xl text-gray-800 font-bold mb-1 ">{title}</h1>
                    <div className='whitespace-pre-line mt-4 leading-relaxed'>{desc}</div>
                    <div>
                        {actions}
                    </div>
                </div>

                {/* Background illustration */}
                <div className="pointer-events-none " aria-hidden="true">
                    {children}
                    {img && <img src={img} alt="" height='' width="360px" className="rounded-md shadow-md" ></img>}
                </div>
            </div>


        </div>
    );
}

SectionBanner.propTypes = {
  title: PropTypes.node,
  desc: PropTypes.node,
  img: PropTypes.string,
  children: PropTypes.node,
  actions: PropTypes.node,
};

export default SectionBanner;

